"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

import { isAuthenticated } from "@/lib/api";

export default function HomePage() {
  const router = useRouter();

  useEffect(() => {
    if (!isAuthenticated()) {
      router.replace("/sign-in");
      return;
    }
    router.replace("/keuangan/ringkasan");
  }, [router]);

  return (
    <div className="flex h-svh w-full items-center justify-center text-sm text-muted-foreground">
      Mengalihkan…
    </div>
  );
}
